const NAMESPACE = 'DUCKS/WIDGET';

export default NAMESPACE;
